import { apiHelper } from "@/utils";
import { API } from "@/constants";

const URL = `${API.BASE_URL_API}/v1/meeting-rooms`;
export const meetingRoomService = {
  getAll,
  store,
  show,
  update,
  updateStatus,
  softDelete,
};

export function getAll(filter = {}) {
  const params = {
    page: filter.pageNumber,
    size: filter.pageSize,
    sortBy: filter.sortBy,
    orderBy: filter.orderBy,
  };
  if (filter.searchArray?.length) params.search_words = filter.searchArray;
  return apiHelper(URL).get("", { params });
}

function toFormData(data, method = null) {
  const value = new FormData();
  value.append("code", data.code);
  value.append("office_uuid", data.officeUUID);
  value.append("company_uuid", data.companyUUID);
  value.append("name", data.name);
  value.append("capacity", data.capacity);
  value.append("pic_user_uuid", data.picUserUUID);

  if (data.image instanceof File) value.append("image", data.image);
  value.append("description", data.description || "");
  value.append("is_muslim_friendly", data.isMuslimFriendly ? 1 : 0);
  value.append("is_active", data.isActive ? 1 : 0);

  (data.amenityUUIDs || []).forEach((uuid, index) =>
    value.append(`amenity_uuids[${index}]`, uuid),
  );
  if (method) value.append("_method", method);
  
  return value;
}

export function store(data) {
  return apiHelper(URL).post("", toFormData(data));
}
export function show(uuid) {
  return apiHelper(URL).get(`/${uuid}`);
}
export function update(data) {
  return apiHelper(URL).post(`/${data.uuid}`, toFormData(data, "PUT"));
}
export function updateStatus(uuid, isActive) {
  return apiHelper(URL).patch(`/status/${uuid}`, {
    is_active: isActive ? 1 : 0,
  });
}
export function softDelete(uuid) {
  return apiHelper(URL).patch(`/delete/${uuid}`);
}
